import React from "react";
import { FilePanelDescription, FilePanelTitle } from "../../components";

const FileExport = ({ title, description, className, children }) => {
  return (
    <div className="export__page-container flex justify-left items-center mt-6 2xl:min-w-[1200px] xl:min-w-[1000px] lg:min-w-[800px] md:min-w-[620px]">
      <div className="upload-file__panel xl:pt-10 xl:pb-6 xl:px-28 pt-4 px-3">
        <FilePanelTitle title={title} />
        <FilePanelDescription
          description={description}
          className="xl:my-4 my-3"
        />
        <div className={`button-group flex justify-center xl:pt-[10px] xl:pb-10 pt-2 pb-[32px] ${className}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default FileExport;
